<div class="flex justify-between bg-grey-veryLight mb-3 p-2">
	<app-button
		[loading]="backButtonLoading"
		[icon]="ICON.BACK"
		size="small"
		(click)="beforeClose()"
	>
		Back to file
	</app-button>
	<div class="flex items-center">
		<atomic-matter-type-icon [fileType]="fileType" />
		<span class="mx-3">{{ matterNumber }}</span>
		<span>{{ matterName }}</span>
	</div>
</div>

<div
	*ngIf="loading && !iframeUrl"
	class="flex flex-1 flex-col justify-center items-center"
>
	<div class="w-64">
		<img src="/assets/images/integrations/title-plus-logo.svg" />
	</div>
	<div class="mt-10 flex items-center">
		<app-icon
			[icon]="ICON.LOADING"
			class="text-4xl mr-3 text-grey"
			[spin]="true"
		/>
		<h4 class="text-grey">
			<span *ngIf="loading">Loading Portal</span>
		</h4>
	</div>
</div>

<div
	*ngIf="hasError && !loading"
	class="flex flex-col justify-center items-center"
>
	<div
		class="flex flex-col justify-center items-center border border-grey-light bg-grey-lightest p-5"
	>
		<div *ngIf="errorMessage">
			<div *ngIf="errorMessage !== AUTH_ERROR">{{ errorMessage }}</div>
			<div *ngIf="errorMessage === AUTH_ERROR">
				<p class="mb-4 text-center">
					<app-icon [icon]="ICON.WARNING" class="mr-4 text-orange" />
					Authentication error
				</p>
				<p class="mb-4 text-center">
					Your TitlePLUS connection is incomplete or expired. Please go to the
					<span
						class="text-blue hover:underline cursor-pointer"
						(click)="goToIntegration()"
					>
						integrations page
					</span>
					to connect to TitlePLUS.
				</p>
			</div>
		</div>
		<div class="flex flex-col" *ngFor="let errorMessage of errorMessages">
			<p class="mb-4 text-center">
				<app-icon [icon]="ICON.WARNING" class="mr-4 text-orange" />
				{{ errorMessage }}
			</p>
		</div>
	</div>
</div>

<div class="flex flex-1" *ngIf="iframeUrl">
	<div class="flex flex-col flex-1 w-full">
		<iframe
			id="title-plus-iframe"
			[src]="iframeUrl"
			width="100%"
			height="100%"
			class="flex flex-1"
		></iframe>
	</div>
</div>
